import { z } from 'zod';
import { createPortalToolOutputSchema } from './portal-tool.schemas';
import { TRACK_HISTORY_REQUEST_TOOL_NAME } from './portal-tool.constants';

export { TRACK_HISTORY_REQUEST_TOOL_NAME };

export const TrackHistoryRequestInputSchema = z.object({
  requestId: z.string().describe('The proxy history requestId to track'),
  credentialId: z
    .string()
    .optional()
    .describe('Optional credential ID to associate with the tracked request'),
  allowNotFoundResponse: z
    .boolean()
    .optional()
    .describe(
      'Set true only when the user explicitly asked to track this request even if the response status is 404. Default is false — 404s are rejected.',
    ),
});

export const TrackHistoryRequestDataSchema = z.object({
  requestId: z.string(),
  tracked: z.boolean(),
  skipped: z.boolean().optional(),
});

export const TrackHistoryRequestOutputSchema = createPortalToolOutputSchema({
  dataSchema: TrackHistoryRequestDataSchema,
});

export type TrackHistoryRequestInput = z.infer<
  typeof TrackHistoryRequestInputSchema
>;
export type TrackHistoryRequestOutput = z.infer<
  typeof TrackHistoryRequestOutputSchema
>;
export type TrackHistoryRequestData = z.infer<
  typeof TrackHistoryRequestDataSchema
>;
